document.addEventListener('DOMContentLoaded', function() {
  // Section animations with parallax for elements with data-parallax attribute
  const sections = document.querySelectorAll('#MainContent section:not([data-no-animate]):not(.product-section):not(.collection-grid-section)');
  
  // Parallax effect
  const parallaxElements = new Map(); // Store element positions

  // Initialize parallax data for elements with data-parallax attribute
  const initParallax = () => {
    document.querySelectorAll('[data-parallax]').forEach(element => {
      const rect = element.getBoundingClientRect();
      // Get speed from data attribute, default to 1 if not specified
      const speed = parseFloat(element.dataset.parallax) || 1;
      
      parallaxElements.set(element, {
        initialY: rect.top + window.pageYOffset,
        height: rect.height,
        speed: speed
      });
    });
  };

  // Initial setup
  initParallax();

  // Update parallax on window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initParallax, 100);
  });

  // Handle scroll for parallax
  const updateParallax = () => {
    const scrolled = window.pageYOffset;
    const viewportHeight = window.innerHeight;
    
    parallaxElements.forEach((data, element) => {
      const { initialY, height, speed } = data;
      
      // Calculate how far the element is from the top of the viewport
      const elementTop = initialY - scrolled;
      
      // Calculate the percentage of the element's travel through the viewport
      // This will be negative when the element is above the viewport,
      // between 0 and 1 while in the viewport, and > 1 when below
      const progress = -elementTop / viewportHeight;
      
      // Apply parallax effect when element is near or in viewport
      if (elementTop < viewportHeight + height && elementTop > -height) {
        const isMobile = window.innerWidth < 768;
        const parallaxSpeed = isMobile ? 30 : 100; // Reduced speed on mobile
        const parallaxOffset = parallaxSpeed * (0.5 - progress);
        element.style.transform = `translateY(${parallaxOffset}px)`;
      }
    });
    
    requestAnimationFrame(updateParallax);
  };

  // Start the animation loop
  requestAnimationFrame(updateParallax);

  // Section fade in animation
  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add a small delay before adding the animated class to ensure visibility
        setTimeout(() => {
          entry.target.classList.add('animated');
        }, 50);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '50px' // Trigger animations slightly before sections come into view
  });

  // Add animation class to all sections immediately
  sections.forEach(section => {
    section.classList.add('animate-section');
    // Check if section is already in view on page load
    const rect = section.getBoundingClientRect();
    const isInView = rect.top < window.innerHeight && rect.bottom > 0;
    if (isInView) {
      section.classList.add('animated');
    } else {
      sectionObserver.observe(section);
    }
  });

  // Handle responsive iframes in blog posts
  const wrapIframe = (iframe) => {
    // Get the iframe's aspect ratio
    const width = iframe.width || iframe.getAttribute('width') || 16;
    const height = iframe.height || iframe.getAttribute('height') || 9;
    const ratio = (height / width) * 100;

    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'responsive-iframe-wrapper';
    wrapper.style.position = 'relative';
    wrapper.style.width = '100%';
    wrapper.style.paddingTop = ratio + '%';

    // Style iframe
    iframe.style.position = 'absolute';
    iframe.style.top = '0';
    iframe.style.left = '0';
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = '0';

    // Wrap iframe
    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);
  };

  // Find all iframes in blog posts and wrap them
  const blogContent = document.querySelector('.article-content__wrapper');
  if (blogContent) {
    const iframes = blogContent.querySelectorAll('iframe');
    iframes.forEach(wrapIframe);
  }

  // Product tile animations
  const products = document.querySelectorAll('#MainContent .grid__item');
  
  const productObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('animated');
        }, index * 100);
        productObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '50px'
  });

  products.forEach(product => {
    product.classList.add('animate-product');
    productObserver.observe(product);
  });

  // Image loading shimmer effect
  const productImages = document.querySelectorAll('#MainContent .grid__item img');
  productImages.forEach(img => {
    const wrapper = img.parentElement;
    wrapper.classList.add('product-image-loading');
    
    img.addEventListener('load', () => {
      wrapper.classList.add('product-image-loaded');
    });

    // If image is already loaded
    if (img.complete) {
      wrapper.classList.add('product-image-loaded');
    }
  });

  // Meter animations
  const meters = document.querySelectorAll('#MainContent .meter-value');
  const meterObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        const meter = entry.target;
        // Get the meter value from the data attribute set in the HTML
        const meterValue = meter.dataset.meterValue || '0';
        const targetWidth = meterValue + '%';
        
        // Ensure we start at 0
        meter.style.transition = 'none';
        meter.style.width = '0%';
        
        // Force a reflow to ensure the 0% width is applied
        meter.offsetHeight;
        
        setTimeout(() => {
          meter.style.transition = 'width 1s ease-out';
          meter.style.width = targetWidth;
        }, 1000 + (index * 200)); // 1s initial delay + stagger
        
        meterObserver.unobserve(meter);
      }
    });
  }, {
    threshold: 0.1
  });

  meters.forEach(meter => {
    meterObserver.observe(meter);
  });

  // Product detail page image loading states
  const handleProductMedia = () => {
    const mediaList = document.querySelector('.product__media-list');
    if (!mediaList) return;

    // Add loading state immediately
    mediaList.style.minHeight = '300px';

    const productDetailImages = mediaList.querySelectorAll('.product__media-item img, .product__media-item video');
    let loadedItems = 0;
    const totalItems = productDetailImages.length;

    productDetailImages.forEach(media => {
      const wrapper = media.closest('.product__media-item');
      if (!wrapper) return;
      
      // Add loading state
      wrapper.classList.add('media-loading');
      
      const markAsLoaded = () => {
        media.style.opacity = '1';
        wrapper.classList.add('media-loaded');
        loadedItems++;
        
        // When all media is loaded, mark slider as initialized
        if (loadedItems === totalItems) {
          mediaList.classList.add('slider-initialized');
        }
      };
      
      if (media.tagName === 'IMG') {
        // Handle images
        media.style.opacity = '0';
        media.style.transition = 'opacity 0.3s ease-out';
        
        const handleLoad = () => {
          // Short delay to ensure smooth transition
          setTimeout(markAsLoaded, 100);
        };

        media.addEventListener('load', handleLoad);
        // If image is already loaded
        if (media.complete) {
          handleLoad();
        }
      } else if (media.tagName === 'VIDEO') {
        // Handle videos
        media.style.opacity = '0';
        media.style.transition = 'opacity 0.3s ease-out';
        
        media.addEventListener('loadeddata', () => {
          setTimeout(markAsLoaded, 100);
        });
      }
    });
  };

  // Initialize product media loading
  handleProductMedia();

  // Product slider loading states
  const handleProductSlider = () => {
    const productSwiper = document.querySelector('.product-swiper');
    if (!productSwiper) return;

    const slides = productSwiper.querySelectorAll('.swiper-slide');
    slides.forEach(slide => {
      const media = slide.querySelector('img, video');
      if (!media) return;

      if (media.tagName === 'IMG') {
        const handleLoad = () => {
          slide.classList.add('slide-loaded');
        };

        if (media.complete) {
          handleLoad();
        } else {
          media.addEventListener('load', handleLoad);
        }
      } else if (media.tagName === 'VIDEO') {
        media.addEventListener('loadeddata', () => {
          slide.classList.add('slide-loaded');
        });
      }
    });
  };

  // Initialize product slider loading
  handleProductSlider();

  // Re-run when Swiper might reinitialize slides
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        handleProductSlider();
      }
    });
  });

  const productSwiper = document.querySelector('.product-swiper');
  if (productSwiper) {
    observer.observe(productSwiper, { childList: true, subtree: true });
  }
}); 